var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light fixed padding block box-shadow text-center vm",staticStyle:{"bottom":"0","left":"0"},attrs:{"slot":"footer"},slot:"footer"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }